module.exports = __webpack_public_path__ + "static/wwf-layout-1838d834df416fd9baf47c00e35707b3.jpg";